import {
    GENERAL_TOPICS_LABEL,
    GENERAL_TOPICS_ROOT, PORTAL_LABEL,
    PORTAL_ROOT,
    PRODUCTS_AND_SERVICES_LABEL,
    PRODUCTS_AND_SERVICES_ROOT, READINESS_LABEL,
    READINESS_ROOT, SEARCH_SORT_POPULAR, SEARCH_SORT_RELEVANCE
} from "../constants/site-search";
import {PF_SORT_ASCENDING, PF_SORT_DESCENDING} from "../constants/product-finder";

export const getSearchSortIndex = (type) => {
    switch (type) {
        case SEARCH_SORT_RELEVANCE: return 0;
        case SEARCH_SORT_POPULAR: return 1;
        case PF_SORT_ASCENDING: return 2;
        case PF_SORT_DESCENDING: return 3;
        default: return 0;
    }
}

export const getCategoryLabel = (tags) => {
    if (!tags || tags.length === 0) return null;
    for (let i = 0; i < tags.length; i += 1) {
        const root = tags[i]?.tagId.split("/")[0];
        if (root.includes(PRODUCTS_AND_SERVICES_ROOT)) return PRODUCTS_AND_SERVICES_LABEL;
        if (root === PORTAL_ROOT) return PORTAL_LABEL;
        if (root === READINESS_ROOT) return READINESS_LABEL;
        if (root === GENERAL_TOPICS_ROOT) return GENERAL_TOPICS_LABEL;
    }
    return null;
}

export const indexOfResultWithPath = (results, path) => {
    for (let i = 0; i < results.length; i += 1) {
        if (results[i].Fields?.pagePath?.Value === path) return i;
    }
    return -1;
}

export const getPreviousSearches = () => {
    return JSON.parse(sessionStorage.getItem("previousSearches")) || [];
}